import { createSelector } from 'reselect'

const getLots = state => state.persons.info.lots

export const getTotalLotsSum = createSelector(
  [ getLots ],
  (lots = []) => ({
    sum: lots.reduce((res, item) => {
      res = res + item.sum
      return res
    }, 0),
    currency: lots[0] ? lots[0].currency : '₽'
  })
)

//получаем - список фондов
export const getFunds = createSelector(
  [ getLots ],
  (lots = []) => {
    const arr = []
    const filteredFund = []

    //фильтрация для получения списка из неповторяющихся фондов 
    lots.forEach(lot => {
      if(arr.indexOf(lot.targetId) === -1) {
        arr.push(lot.targetId)
        filteredFund.push({id: lot.targetId, name: lot.name})
      }
    })

    return {
      items: filteredFund,
      count: filteredFund.length
    }
  }
)


// WEBPACK FOOTER //
// ./src/selectors/person.js